
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sebeprovereni",
      function () {
        return require("private-next-pages/sebeprovereni/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sebeprovereni"])
      });
    }
  